import { render } from "./CRA_summary.vue?vue&type=template&id=023dd889&scoped=true"
import script from "./CRA_summary.js?vue&type=script&lang=js"
export * from "./CRA_summary.js?vue&type=script&lang=js"

import "./CRA_summary.vue?vue&type=style&index=0&id=023dd889&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023dd889"]])

export default __exports__